import { Button, CloseButton } from '@chakra-ui/react';
import { useUpdateStore } from '@/store/update/store';
import classes from './index.module.scss';
import IconUpdate from './images/update.svg?react';

export interface UpdateBarProps {
  className?: ClassNames;
}

export default function UpdateBar({ className }: UpdateBarProps) {
  const { t } = useTranslation();
  const { updateInfo } = useUpdateStore();
  const [showUpdate, setShowUpdate] = useState(false);

  useLayoutEffect(() => {
    if (updateInfo) {
      setShowUpdate(true);
    }
  }, [updateInfo]);

  if (showUpdate) {
    return (
      <div className={cls(classes.mainBar, className)}>
        <span className={classes.text}>{t('settings.newVersion')}</span>

        <Button
          size="xs"
          onClick={async () => {
            location.reload();
          }}
        >
          <IconUpdate></IconUpdate>
          {t('settings.updateNow')}
        </Button>

        <CloseButton
          className={classes.close}
          size="xs"
          color="white"
          onClick={() => {
            setShowUpdate(false);
          }}
        ></CloseButton>
      </div>
    );
  }

  return null;
}
